import { render, staticRenderFns } from "./ProgressDonut.vue?vue&type=template&id=51e2124e&"
import script from "./ProgressDonut.vue?vue&type=script&lang=js&"
export * from "./ProgressDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports